export const CONTACT_EMAIL = 'premiumtipsters@tip1x2bet.com';

export const FAQ = [
  {
    q: 'What is the difference between the three tipsters?',
    a: 'Each works in a different format. Turkish Team releases one Daily Double (two matches combined). Asian Tips releases one Asian Handicap single per day. 24 BOX Tips releases one straightforward single per day at odds around 2.00. You subscribe to the tipster whose format suits you.'
  },
  {
    q: 'Can I subscribe to more than one tipster?',
    a: 'Yes. Every subscription is independent, so you can combine any two or all three. Mention the tipsters you want in your request and we will send one set of payment instructions.'
  },
  {
    q: 'When are the selections delivered?',
    a: 'By email, once the final check is complete — normally several hours before the first kick-off. 24 BOX Tips always releases inside the 24-hour window before the match.'
  },
  {
    q: 'What happens on days with no pick?',
    a: 'If a tipster finds nothing that meets their criteria, no selection is released and the day is recorded in the archive as "No pick". Your subscription period is not affected — we never force a selection to fill a slot.'
  },
  {
    q: 'Do you guarantee profit?',
    a: 'No. Nobody can. Football is uncertain and losing days are part of every record — you can see all of them in each archive. What we offer is disciplined research and a transparent record, not a promise of results.'
  },
  {
    q: 'Which payment methods do you accept?',
    a: 'PayPal, Skrill, Neteller, bank card and crypto (USDT TRC20 & BEP20). Choose a tipster and duration, send us a request and we reply with secure payment instructions.'
  },
  {
    q: 'What happens if a match is postponed?',
    a: 'A postponed or abandoned selection is treated as void. For a Double, the remaining selection stands on its own odds. The day is recorded accordingly in the archive.'
  }
];
